import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import thunk from "redux-thunk";

import reducers from "./reducers";

import './style/style.css';
import home from './pages/home';
import signup from './pages/auth/signup';
import signin from './pages/auth/signin';
import signout from './pages/auth/signout';
import message from './pages/message';
import add from './pages/add';
import view from './pages/view';
import App from './pages/app';
import RequireAuth from './components/require_auth';
import registerServiceWorker from './registerServiceWorker';

import { AUTH_USER, UNAUTH_USER } from './actions/types.js'

const store = createStore(
  reducers,
  applyMiddleware(thunk)
);

const token = localStorage.getItem('token');
// If we have a token, consider the user to be signed in
if (token) {
  // we need to update application state
    store.dispatch({ type: AUTH_USER });
} else {
    store.dispatch({ type: UNAUTH_USER });
}

ReactDOM.render(
    <Provider store={store}>
      <Router history={browserHistory}>
          <Route path="/" component={App}>
            <IndexRoute component={home} />
            <Route path="signin" component={signin} />
            <Route path="signup" component={signup} />
            <Route path="message" component={message} />
            <Route path="add" component={RequireAuth(add)} />
            <Route path="view" component={RequireAuth(view)} />
            <Route path="signout" component={RequireAuth(signout)} />
          </Route>
      </Router>
    </Provider>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js